import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticClass: "pa-0 ma-0",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VChipGroup, {
    attrs: {
      "column": ""
    }
  }, [_c(VChip, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.titleAccount')) + ": \n          "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n            " + _vm._s((_vm.viewModel || {}).account) + "\n          ")])]), _vm._l(_vm.displaySearchChips, function (tag, idx) {
    return _c(VChip, {
      key: `chip-${idx}`,
      attrs: {
        "small": ""
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.props')[tag.variable] || tag.variable) + "\n          " + _vm._s(tag.condition === 'isnot' ? _vm.$i18n_t('Core.MultiSearch.conditions.isNot') : _vm.$i18n_t('Core.MultiSearch.conditions.is')) + ": \n          "), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n            " + _vm._s((tag.search || {}).text === undefined ? tag.search : tag.search.text) + "\n          ")])]);
  })], 2)], 1), _c(VCol, {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSpacer), _c('core-date-time-picker-flat', {
    attrs: {
      "isRange": "",
      "initialRange": "now-7d",
      "to": _vm.timeRange.to,
      "minDate": _vm.datePickerMinDate
    },
    on: {
      "date:picked": _vm.setTimeRange
    }
  })], 1)], 1), _c('custom-multi-search', {
    attrs: {
      "data-cy": "quick_search",
      "searchTypes": _vm.filteredSearchTypes,
      "searchItems": _vm.searchItems,
      "operator": _vm.searchOperator,
      "defaultSearchType": _vm.defaultSearchType,
      "showOperatorDropdown": "",
      "dense": ""
    },
    on: {
      "updated": _vm.searchUpdated
    }
  }), _c(VRow, [_c(VCol, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.kpis')))]), (_vm.viewPackets || {}).devices === undefined ? [_c(VSkeletonLoader, {
    staticClass: "pt-0 mb-2",
    staticStyle: {
      "height": "96px"
    },
    attrs: {
      "type": "image"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "pt-0",
    staticStyle: {
      "height": "96px"
    },
    attrs: {
      "type": "image"
    }
  })] : _c('core-virtual-device-smart-group-statistics-card', {
    key: `1337-card`,
    attrs: {
      "id": (_vm.viewModel || {}).id,
      "last24Hours": (_vm.viewPackets || {}).last24Hours,
      "prior24Hours": (_vm.viewPackets || {}).prior24Hours,
      "devices": (_vm.viewPackets || {}).devices,
      "errors": (_vm.viewPackets || {}).errors,
      "warnings": (_vm.viewPackets || {}).warnings,
      "loading": _vm.isFetchingExecute
    }
  })], 2), _c(VCol, [_c('core-virtual-device-packet-viewer', {
    attrs: {
      "height": 200,
      "headline": _vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.livePacketViewHeadline'),
      "noPacketLabel": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.noNewPacketsYet'),
      "bridgeManifest": null,
      "packetHistory": _vm.packetHistory,
      "dataIsLoading": false,
      "loadingDone": "",
      "isLiveViewer": "",
      "valuePath": "value"
    },
    scopedSlots: _vm._u([{
      key: "tableHeader",
      fn: function () {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }), _c('td', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Connectors.payload')))]), _c('td', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.props.deviceId')))])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-sync-alt"
    },
    on: {
      "click": _vm.forceFetchViewDetails
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.update')) + "\n      ")]), _vm.lastGraphsDataFetch > 0 ? [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate')) + ": " + _vm._s(_vm.localizeDate(_vm.lastGraphsDataFetch)) + "\n      ")] : _vm._e()], 2)], 1), _c(VRow, [_c(VCol, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.hourlyPackets')))]), _vm.isLoadingPacketMetrics ? _c(VSkeletonLoader, {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "image"
    }
  }) : _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": _vm.chartsHeight,
      "multi-chart-data-t": _vm.hourlyMetricsComp,
      "options": _vm.hourlyMetricOptions
    }
  })], 1), _c(VCol, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.dailyPackets')))]), _vm.isLoadingPacketMetrics ? _c(VSkeletonLoader, {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "image"
    }
  }) : _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": _vm.chartsHeight,
      "multi-chart-data-t": _vm.dailyMetricsComp,
      "options": _vm.packetMetricsOptions
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('AlarmLogs.smartGroup.charts.byCategory.title')))]), _vm.isLoadingAlarmLogs ? _c(VSkeletonLoader, {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "image"
    }
  }) : _c('core-virtual-device-smart-groups-charts-alarm-logs-by-category', {
    attrs: {
      "alarmLogs": _vm.alarmLogs
    }
  })], 1), _c(VCol, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('AlarmLogs.smartGroup.charts.byDayNewVersusResolved.title')))]), _vm.isLoadingAlarmLogs ? _c(VSkeletonLoader, {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "image"
    }
  }) : _c('core-virtual-device-smart-groups-charts-alarm-logs-by-day-new-versus-resolved', {
    attrs: {
      "alarmLogs": _vm.alarmLogs,
      "timeRange": _vm.timeRange
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };